// extracted by mini-css-extract-plugin
module.exports = {"beginButton":"test-begin-button-module__beginButton___20szQ","disabled":"test-begin-button-module__disabled___10_EO","angleRight":"test-begin-button-module__angleRight___1Fo6K"};